<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      布吉站<br>
站点介绍<br>
布吉站位于深圳市龙岗区布吉铁东路与龙岗大道交汇处，车站主体沿龙岗大道呈东西走向布置，东接石芽岭站，西接罗湖北站，西侧连接东站交通枢纽西广场和深圳东火车站，通过东站交通枢纽连接吉华路；东侧为龙岗大道，有可域酒店；北侧为铁东路，有东站交通枢纽公交场站；南侧为百鸽路，有百合酒店；14号线车站色彩基调以树干暖色调为主，以“阳光+”生长为主题，体现14号线绿意盎然的生态特色主题空间。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:02	23:36	3号线	2分15-20秒	4分30秒<br>
双龙	06:13	23:37	3号线	2分15-20秒	4分30秒<br>
赤湾	06:08	23:15	5号线	3分钟	5分25秒<br>
黄贝岭	06:12	00:06	5号线	3分钟	5分25秒<br>
岗厦北	06:31	23:44	14号线	4分30秒	6分15秒<br>
沙田	06:10	23:40	14号线	4分30秒	6分15秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:11	23:35	3号线	3分15秒	5分钟<br>
双龙	06:22	23:37	3号线	3分15秒	5分钟<br>
赤湾	06:20	23:15	5号线	4分钟	6分钟<br>
黄贝岭	06:14	00:06	5号线	4分钟	6分钟<br>
岗厦北	06:44	23:44	14号线	5分25秒	6分15秒<br>
沙田	06:10	23:40	14号线	5分25秒	6分15秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:11	00:35	3号线	3分15秒	5分钟<br>
双龙	06:22	00:37	3号线	3分15秒	5分钟<br>
赤湾	06:20	00:15	5号线	4分钟	6分钟<br>
黄贝岭	06:14	01:06	5号线	4分钟	6分钟<br>
岗厦北	06:44	00:44	14号线	5分钟	6分15秒<br>
沙田	06:10	00:40	14号线	5分钟	6分15秒<br><br>

站点出口信息<br><br>
A出入口:<br>
龙岗大道北侧、京南路、佳兆业大都会、布吉新村<br><br>
C出入口:<br>
龙岗大道北侧（西）、深圳东站东广场D出入口<br><br>
E1出入口:<br>
龙岗大道南侧（东）、龙威花园<br><br>
E2出入口:<br>
龙岗大道南侧（东）、龙珠花园<br><br>
西广场通道:<br>
深圳东站B出入口、深圳东站西广场、布吉街、布吉公园（医院）、吉华路、莲花路、宝利路、西环路、农业银行、中国银行、邮政银行、农业商业银行、工商银行、深圳东站售票厅、国税局、铁西路<br><br>
东2出入口:<br>
龙珠花园（商城）、龙岗大道、南门墩、铁东路、布吉天虹、京南工业区、华美工业区、布沙路、吉政路、国土局、吉达花园<br><br>
东3出入口:<br>
深圳东站东广场总站<br><br>
东4出入口:<br>
可域酒店、百合星城、罗岗医院（派出所）、百合路、招商银行、工商银行、平安银行<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 深圳东站②<br>
M265、M271、M283、M329路、M358、M404、M408、M415、M485、深惠3A线、M406<br><br>
D出入口:<br>
公交站名： 深圳东站①<br>
8、321、322、357、366、371、376、977、M172、M183、M192、M203、M224、M239、M588<br><br>
E2出入口:<br>
公交站名： 深圳东站②<br>
M265、M271、M283、M329路、M358、M404、M408、M415、M485、深惠3A线、M406<br><br>
C出入口:<br>
公交站名： 深圳东站东广场<br>
M139、M244、M295、M311、M589、梧桐山假日专线2、E24<br><br>
C出入口:<br>
公交站名： 深圳东站西广场<br>
980、M541、M273、85<br><br>
东3出入口:<br>
公交站名： 深圳东站交通枢纽公交场站<br>
M415、E24、M139、M244、M295、M310、梧桐山假日专线2路<br><br>
东1出入口:<br>
公交站名： 深圳东站①<br>
321、322、323、357、366、371、376、398、8、977、M172、M183、M192、M203、M224、M233、M239、M268、M273、M406区间<br><br>
西广场出口:<br>
公交站名： 深圳东站西广场<br>
85、85区间、85越站车、980、M273<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "sanhaoxian",
            title: "3号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "wuhaoxian",
            title: "5号线",
            // icon: "chat",
            exact: true,
          },
          {
            name: "shisihaoxian",
            title: "14号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>